import { Injectable } from '@angular/core';
import { TransformationDto } from '@osos/shared/api';
import { TransformationPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { TransformationParserV1Service } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable()
export class TransformationFactoryService extends FactoryBase<
  TransformationDto,
  TransformationPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: TransformationParserV1Service
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(presenter: TransformationPresenterModel): TransformationDto {
    const parser = this.getParser(
      TransformationDto,
      TransformationPresenterModel,
      1
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: Partial<TransformationDto>
  ): TransformationPresenterModel {
    const parser = this.getParser(
      TransformationDto,
      TransformationPresenterModel,
      1
    );
    const result = parser?.getPresenterModel(model);
    return result;
  }
}
